(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nny-product-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nny-product-benefits')) {
    customElements.define('nny-product-benefits', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.content = this.querySelector('[data-nny-benefits-content]');
        this.fallback = this.content.cloneNode(true);
        this.fallbackHasContent = this.hasAttribute('data-has-content');
        const signal = this.controller.signal;
        const refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.refresh());
        };
        document.addEventListener('shopify:section:load', refresh, {signal});
        document.addEventListener('shopify:section:unload', refresh, {signal});
        document.addEventListener('shopify:section:reorder', refresh, {signal});
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', refresh, {once: true, signal});
        }
        this.refresh();
      }

      refresh() {
        if (!this.isConnected || !this.content) return;
        const product = [...document.querySelectorAll('nny-product[data-product-id]')]
          .find(element => element.dataset.productId === this.dataset.productId);
        const source = product?.querySelector('[data-nny-benefits-source]');
        const list = source?.querySelector('.benefit-grid');
        if (this.source && this.source !== source) this.source.removeAttribute('data-nny-benefits-relocated');
        this.source = source;
        if (list) {
          this.content.replaceChildren(list.cloneNode(true));
          this.setAttribute('data-has-content', '');
          this.setAttribute('data-ready', '');
          source.dataset.nnyBenefitsRelocated = this.dataset.display;
        } else {
          this.content.replaceChildren(...[...this.fallback.childNodes].map(node => node.cloneNode(true)));
          this.toggleAttribute('data-has-content', this.fallbackHasContent);
          this.setAttribute('data-ready', '');
          source?.removeAttribute('data-nny-benefits-relocated');
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.source?.removeAttribute('data-nny-benefits-relocated');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
